import { render, staticRenderFns } from "./DaysOfWeek.vue?vue&type=template&id=7ed38dbc&scoped=true&"
import script from "./DaysOfWeek.vue?vue&type=script&lang=ts&"
export * from "./DaysOfWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed38dbc",
  null
  
)

export default component.exports